import { createContext, Dispatch, ReactNode, useReducer } from 'react'
import { DomainInfo } from '../domain/types'
import { homeReducer } from './reducer'
import { Action, HomeState } from './types'

type HomeDispatch = Dispatch<Action>
export const HomeStateContext = createContext<HomeState | null>(null)
export const HomeDispatchContext = createContext<HomeDispatch | null>(null)

const nowYear = new Date().getFullYear()
const defaultDate = new Date(`${nowYear + 1}-08-01 00:00:00`)

export const initialDomain: DomainInfo = {
  domain: '',
  name: '',
  maxLicense: 0,
  userCount: 0,
  description: '',
  expireTime: defaultDate.toISOString().substring(0, 10),
  updateTime: '',
  createTime: '',
  locale: 'ko',
}

export const initialState: HomeState = {
  debug: false,
  opened: {
    productDropdown: false,
    profileDropdown: false,
    sidemenu: false,
  },
  selected: {
    productType: 'edu',
    domain: initialDomain,
    validEmailType: false,
    adminList: false,
  },
}

export function HomeContextProvider({ children }: { children: ReactNode }) {
  const [home, dispatch] = useReducer(homeReducer, initialState)

  return (
    <HomeDispatchContext.Provider value={dispatch}>
      <HomeStateContext.Provider value={home}>{children}</HomeStateContext.Provider>
    </HomeDispatchContext.Provider>
  )
}
